import { Col, Popover, Row } from "antd";
import Axios from "axios";
import React, { useEffect, useState } from "react";
import BaseInput from "../../BaseInput";
import QalortButton from "../../Button";

function SearchOnline({ selectImage }) {
  const [searchResults, setSearchResults] = useState([]);
  const [showPop, setShowPop] = useState(false);
  const [query, setQuery] = useState("");

  const fetchPhotos = async () => {
    try {
      const res = await Axios.get(
        `https://api.unsplash.com/search/photos?client_id=a78O_H8rkJ2EJ6SR6XcyB1vzmu7ZWjbxtxQiNqRKAL8&query=${query}&per_page=9`
      );
      setSearchResults(res.data.results);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (query) {
      fetchPhotos();
    }
  }, [query]);

  return (
    <div>
      <Popover
        placement="bottom"
        content={
          <div className="w-[90%] md:w-[400px]">
            <BaseInput
              onChange={(e, f) => {
                setQuery(e.target.value);
              }}
              className="mb3"
              placeholder="Type keyword then enter"
            />

            <Row gutter={20}>
              {searchResults.map((im) => (
                <Col span={8}>
                  <div
                    onClick={() => {
                      selectImage(im.urls.regular);
                      setShowPop(false);
                    }}
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      height: 150,
                      backgroundImage: `url(${im.urls.small})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      marginBottom: 12,
                    }}
                  ></div>
                </Col>
              ))}
            </Row>
          </div>
        }
        title={null}
        trigger="click"
        visible={showPop}
        onVisibleChange={(v) => setShowPop(v)}
      >
        <QalortButton className="border border-pri bg-pri-tint-3 pri py-[3px] px-[15px] relative">
          Search online{" "}
        </QalortButton>
      </Popover>
    </div>
  );
}

export default SearchOnline;
